import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useAuth } from "../lib/auth";
import { useLang } from "../lib/lang";
import { Shield, Loader2 } from "lucide-react";

export default function LoginPage() {
  const { user, login } = useAuth();
  const { t } = useLang();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") {
    return <Navigate to={loc.state?.from || "/admin"} replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await login(email.trim(), password);
    setLoading(false);
    if (!r.ok) setError(r.error || "Login failed");
  }

  return (
    <div className="App" data-testid="login-page">
      <Header />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="border border-slate-300 p-8 bg-white">
          <div className="w-14 h-14 bg-slate-900 text-white flex items-center justify-center mb-6">
            <Shield className="w-7 h-7" strokeWidth={1.5} />
          </div>
          <h1 className="font-display text-3xl text-slate-900 mb-1">{t("admin_login")}</h1>
          <p className="text-sm text-slate-500 mb-8">Authorized personnel only.</p>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-semibold text-slate-700 mb-2">
                {t("email")}
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="w-full border border-slate-300 px-4 py-3 focus:outline-none focus:border-slate-900 transition"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-semibold text-slate-700 mb-2">
                {t("password")}
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full border border-slate-300 px-4 py-3 focus:outline-none focus:border-slate-900 transition"
              />
            </div>
            {error && (
              <div className="text-sm text-red-600 border-l-4 border-red-600 bg-red-50 px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-slate-900 text-white py-3 text-sm uppercase tracking-[0.2em] font-semibold hover:bg-red-600 transition flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              {t("signin")}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
